module.exports = __webpack_public_path__ + "static/media/Content_Purchase.3a90268a.svg";